import { useEffect, useMemo, useState } from "react";
import api from "../services/api";

export function useWeddingComposites(params = {}) {
  const [composites, setComposites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // stable query string from params (supports { keys: ['A','B'], active: 'true'|'false'|'any' })
  const qs = useMemo(() => {
    const p = new URLSearchParams();
    if (Array.isArray(params.keys) && params.keys.length) {
      p.set("keys", params.keys.join(","));
    }
    if (params.active) p.set("active", String(params.active));
    const s = p.toString();
    return s ? `?${s}` : "";
  }, [JSON.stringify(params || {})]);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      setLoading(true);
      setError("");
      try {
        const { data } = await api.get(`/weddings/composites${qs}`);
        if (!cancelled)
          setComposites(Array.isArray(data?.composites) ? data.composites : []);
      } catch (e) {
        if (!cancelled) setError("Failed to load wedding composites.");
        // eslint-disable-next-line no-console
        console.error("useWeddingComposites error:", e);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [qs]);

  // handy map by key (and aliases) for quick lookups
  const indexByKey = useMemo(() => {
    const map = new Map();
    for (const c of composites) {
      map.set(c.key, c);
      (c.aliases || []).forEach((a) => map.set(a, c));
    }
    return map;
  }, [composites]);

  return { composites, indexByKey, loading, error };
}
